import { FC } from 'react';
import ResponseTemplateCreatorDemo from '../../ResponseTemplateCreator';
import { Tab } from '@scale/scaleui';

export const ResponseTemplating: FC = () => (
  <Tab.Panel>
    <div className="flex items-center justify-between w-full h-full my-4 px-12">
      <ResponseTemplateCreatorDemo />
    </div>
  </Tab.Panel>
);
